module.exports = __webpack_public_path__ + "img/empty.f3f24ba0.png";